import React from "react";

const About = () => (
  <section id="about" className="section">
    <div className="section-head">
      <span className="section-num">01</span>
      <h2>About</h2>
    </div>
    <div className="about-grid">
      <div className="about-text">
        <p>
          I'm a signal processing and algorithm engineer with over three years
          of hands-on experience developing{" "}
          <strong>navigation and detection systems</strong> for the IDF Ground
          Forces, and experience at <strong>Mobileye</strong> validating laser
          systems for an FMCW Lidar platform with MATLAB-based analysis.
        </p>
        <p>
          My roots are in electronics engineering — digital and analog
          circuits, C, assembly for 8051 microprocessors and VHDL — which is
          why I'm at home on both sides of the hardware/software boundary.
        </p>
        <p>
          I'm passionate about software and electronic development alike,
          constantly seeking opportunities to learn new technologies, and
          ready to contribute as a developer in a forward-thinking company.
        </p>
      </div>
      <dl className="facts">
        <div>
          <dt>Role</dt>
          <dd>Algorithm &amp; Embedded Engineer</dd>
        </div>
        <div>
          <dt>Core stack</dt>
          <dd>MATLAB · C/C++ · Python</dd>
        </div>
        <div>
          <dt>Education</dt>
          <dd>B.Sc. Mathematics &amp; Computer Science, Open University of Israel (2024 – present)</dd>
        </div>
        <div>
          <dt>Background</dt>
          <dd>Associate Degree, Electronics Engineering — Rogozin College (2018 – 2020)</dd>
        </div>
        <div>
          <dt>Languages</dt>
          <dd>Hebrew · English</dd>
        </div>
      </dl>
    </div>
  </section>
);

export default About;
